// Force-Build: 2
import appEnv from 'bundles/articles/appEnv';
import appStarterFactory from 'bundles/page/lib/appStarterFactory';

export default appStarterFactory(appEnv);
